module.exports = __webpack_public_path__ + "static/media/generator_ru.00677ccc.jpg";